import { Widget } from "@foretagsplatsen/widgetjs";
import ActionButtonWidget from "../ActionButtonWidget/ActionButtonWidget.js";
import FlipWidget from "../FlipWidget/FlipWidget.js";

/**
 * Displays a button. When clicked, displays some content instead of
 * the button. Sending `showButton()` replaces the content with the button.
 *
 * @param {object} buttonSpec - An object passed as argument to the
 * ActionButtonWidget's constructor to configure its look.
 * @param {Renderable} content - What the user will see in place
 * of the button.
 */
export default class FlipButton extends Widget {
	constructor({ buttonSpec, content } = {}) {
		super(...arguments);

		this._button = new ActionButtonWidget({
			...buttonSpec,
			click: () => this.showContent(),
		});

		this._flipWidget = new FlipWidget({
			frontRenderable: this._button,
			backRenderable: content,
		});
	}

	renderContentOn(html) {
		html.render(this._flipWidget);
	}

	showButton() {
		this._flipWidget.showFront();
	}

	showContent() {
		this._flipWidget.showBack();
	}
}
